"use client";

import { usePathname } from "next/navigation";
import Navbar from "@/components/layout/Navbar";

export default function ConditionalNavbar() {
  const pathname = usePathname();

  const hideNavbar = pathname.startsWith("/plan-purchase");

  if (hideNavbar) {
    return null;
  }

  return <Navbar />;
}